export default __webpack_public_path__ + "static/notificare-actito-logo-22dbda540d20f8aa8ea78148d4fa2afc.svg";